const SemVer = require('../classes/semver')
const compare = (a, b, loose) =>
  new SemVer(a, loose).compare(new SemVer(b, loose))

module.exports = compare



//////////////////
// WEBPACK FOOTER
// ./~/jsonwebtoken/~/semver/functions/compare.js
// module id = 12
// module chunks = 0